import { PropsWithChildren } from 'react'

import styled, { css } from 'styled-components'

interface InputProps {
  isInvalid: boolean
  isDisabled: boolean
}

export const Input = styled.input.attrs<PropsWithChildren<InputProps>>({})<InputProps>`
  ${({ theme, isInvalid, isDisabled }) => css`
    width: 100%;
    height: 48px;
    padding: 4px 10px;

    font-size: 16px;
    color: ${isDisabled ? theme.colors.textFormDisabled : theme.colors.text};

    border-width: ${isInvalid ? 2 : 1}px;
    border-color: ${
      isInvalid
        ? theme.colors.textError
        : isDisabled
          ? theme.colors.formBorderDisabled
          : theme.colors.formBorder
    }
    border-radius: 8px;
  `}
`

export const FormInputContainer = styled.div`
  margin-bottom: 15px;
`
